import { render, staticRenderFns } from "./friendpass.vue?vue&type=template&id=cdebc0ca"
import script from "./friendpass.vue?vue&type=script&lang=js"
export * from "./friendpass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports